angular.module('app').directive('filtroDoacoes', function() {
	return {
        restrict: 'E',
        templateUrl: '/html/filtro-doacoes.html?v='+angular.element('meta[name="version-id"]').attr('content'), 
        controller: function($scope) {

            $scope.initFiltro = function(){
                console.log('oi');
                var u = new URI();
                var query = u.search(true);
                var filtro = angular.fromJson(query.filtro);
                
                if(filtro){
                    $scope.ngModel = {
                        'candidato': filtro.candidato ? filtro.candidato : '',
                        'uf': filtro.uf ? filtro.uf : '',
                        'cargo_id': filtro.cargo_id ? filtro.cargo_id : '',
                    };
                }else{
                    $scope.ngModel = {};
                }
            };

            $scope.filtrar = function($event){
                $event.preventDefault();

                var u = new URI('/lista-doacoes');

                u.removeSearch('filtro');
                u.addSearch({
                    filtro: angular.toJson($scope.ngModel)
                });

                window.location.href = u.toString();
            };
        },
        link: function ($scope) {
            $scope.initFiltro();
        }
    };
});